import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  IconButton,
  Chip,
  Stack,
} from "@mui/material";
import { CloudUpload, Close, AddAPhotoOutlined } from "@mui/icons-material";
import apiEndpoints from "../../apiconfig";

const UploadHoroscope = ({
  form,
  handleSingleImageUpload,
  setField,
  showErrors,
}) => {
  // Helper function to get the image URL regardless of format
  const getImageUrl = (imageData) => {
    if (!imageData) return null;
    if (typeof imageData === "string") return imageData; // API returns string URL
    if (typeof imageData === "object" && imageData.url) return imageData.url; // New upload
    return null;
  };

  // Helper function to get the image name
  const getImageName = (imageData) => {
    if (!imageData) return "";
    if (typeof imageData === "string") return "Existing horoscope";
    if (typeof imageData === "object" && imageData.name) return imageData.name;
    return "Unknown";
  };

  const imageUrl = getImageUrl(form.horoscope);

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
        Upload Horoscope Image
      </Typography>

      {showErrors && !imageUrl && (
        <Typography color="error" variant="body2" sx={{ mb: 2 }}>
          Horoscope image is required
        </Typography>
      )}

      <Card
        variant="outlined"
        sx={{ borderStyle: "dashed", mb: 2, cursor: "pointer" }}
        onClick={() => document.getElementById("horoscope-input")?.click()}
      >
        <CardContent sx={{ textAlign: "center" }}>
          <CloudUpload sx={{ fontSize: 44, mb: 1 }} />
          <Typography>Click to choose an image (JPG/PNG)</Typography>
          <input
            id="horoscope-input"
            type="file"
            accept="image/jpeg,image/jpg,image/png"
            style={{ display: "none" }}
            onChange={(e) => handleSingleImageUpload(e, "horoscope")}
          />
        </CardContent>
      </Card>

      {imageUrl && (
        <Stack direction="row" spacing={2} alignItems="center">
          <img
            src={
              typeof form.horoscope === "object"
                ? imageUrl
                : `${apiEndpoints.image}${imageUrl}`
            }
            alt={getImageName(form.horoscope)}
            style={{
              width: 140,
              height: 140,
              objectFit: "cover",
              borderRadius: 8,
            }}
          />
          <Stack direction="row" spacing={1} alignItems="center">
            <Chip label={getImageName(form.horoscope)} />
            <IconButton onClick={() => setField("horoscope", null)}>
              <Close />
            </IconButton>
          </Stack>
        </Stack>
      )}
    </Box>
  );
};

export default UploadHoroscope;
